import type { LucideIcon } from "lucide-react";
import {
  Brain,
  FileText,
  FolderOpen,
  Globe,
  Inbox,
  LayoutGrid,
  Monitor,
} from "lucide-react";
import { VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";

export const MARKETING_STACK_VIEW_TYPES = [
  VIEW_TYPES.context,
  VIEW_TYPES.marketingManifest,
  VIEW_TYPES.coverage,
  // Promote Surface remains routed but is hidden from navigation (HQ staging).
  VIEW_TYPES.promote,
  VIEW_TYPES.workFiles,
  VIEW_TYPES.marketingPages,
  VIEW_TYPES.site,
  VIEW_TYPES.leads,
] as const;

export type MarketingStackViewType = (typeof MARKETING_STACK_VIEW_TYPES)[number];

export type MarketingStackStep = {
  viewType: MarketingStackViewType;
  label: string;
  viewName: string;
  icon: LucideIcon;
};

export const MARKETING_STACK_STEPS: readonly MarketingStackStep[] = [
  { viewType: VIEW_TYPES.context, label: "Context", viewName: "Context", icon: Brain },
  {
    viewType: VIEW_TYPES.marketingManifest,
    label: "Manifest",
    viewName: "Marketing Manifest",
    icon: FileText,
  },
  { viewType: VIEW_TYPES.coverage, label: "Coverage", viewName: "Coverage", icon: LayoutGrid },
  {
    viewType: VIEW_TYPES.workFiles,
    label: "Work Files",
    viewName: "Work Files",
    icon: FolderOpen,
  },
  { viewType: VIEW_TYPES.marketingPages, label: "Pages", viewName: "Pages", icon: Monitor },
  { viewType: VIEW_TYPES.site, label: "Site", viewName: "Site", icon: Globe },
  { viewType: VIEW_TYPES.leads, label: "Leads", viewName: "Leads", icon: Inbox },
];
